{
  "name": "qp-cpq-ui",
  "version": "2.21.1",
  "scripts": {
    "ng": "ng",
    "prod": "ng build --configuration production",
    "non-prod": "ng build --configuration nonprod --aot",
    "staging": "ng build --configuration staging --aot",
    "start": "ng serve --configuration nonprod",
    "start:dev": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration nonprod",
    "test": "ng test"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.3.6",
    "@angular/common": "^20.3.6",
    "@angular/compiler": "^20.3.6",
    "@angular/core": "^20.3.6",
    "@angular/forms": "^20.3.6",
    "@angular/material": "^20.2.9",
    "@angular/platform-browser": "^20.3.6",
    "@angular/platform-browser-dynamic": "^20.3.6",
    "@angular/router": "^20.3.6",
    "@azure/msal-angular": "^4.0.15",
    "@azure/msal-browser": "^4.15.0",
    "@hubspot/api-client": "^11.2.0",
    "@ng-bootstrap/ng-bootstrap": "^19.0.1",
    "@ngx-translate/core": "^14.0.0",
    "@ngx-translate/http-loader": "^7.0.0",
    "@popperjs/core": "^2.11.8",
    "fuzzysort": "^3.1.0",
    "html2pdf.js": "^0.12.1",
    "jwt-decode": "^4.0.0",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "webpack": "^5.99.9",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular/build": "^20.3.6",
    "@angular/cli": "~20.3.6",
    "@angular/compiler-cli": "^20.3.6",
    "@angular/localize": "^20.3.6",
    "@types/jasmine": "~4.3.0",
    "jasmine-core": "~4.5.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.0.0",
    "typescript": "~5.8.3"
  }
}
